export const setValue = (key, value) => {
    localStorage.setItem(key,JSON.stringify(value));
    return true;    
}

export const getValue = (key) => {
    const value = localStorage.getItem(key );
    return true;
}

export const removeValue = (key) => {
localStorage.removeItem(key);
return true;
}

export const formatJobDescription = (html) => {
  if (!html) return "";

  // Split by bullet symbol
  const parts = html.split("●").map((p) => p.trim()).filter(Boolean);

  // If no bullets found, return original HTML
  if (parts.length <= 1) return html;

  const firstParagraph = parts.shift(); // content before first bullet

  const listItems = parts
    .map((item) => `<li>${item.replace(/<\/?p>/g, "").trim()}</li>`)
    .join("");

  return `
    ${firstParagraph || ""}
    <ul>
      ${listItems}
    </ul>
  `;
};
